import { render, staticRenderFns } from "./ListThreeLItemsSelect.vue?vue&type=template&id=089b133c&"
import script from "./ListThreeLItemsSelect.vue?vue&type=script&lang=js&"
export * from "./ListThreeLItemsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemGroup})
